import React, { useCallback } from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";
import { useNewsletterContext } from "scmp-sdk/components/newsletter/newsletter-widget/contexts";
import { getTriggerPoint } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/helpers";

import { useActiveElementForNewWindow } from "shared/hooks";

import { Container, Description, FacebookIframe } from "./styles";

export type Props = React.DetailsHTMLAttributes<HTMLDivElement>;

export const FollowUsOnFacebook: React.FunctionComponent<Props> = ({ ...props }) => {
  const { config, handleTrackGA4 } = useSdkContext();
  const { campaignName, lastSubscribedNewsletter, variant } = useNewsletterContext();
  const { activeElement } = useActiveElementForNewWindow();
  const iframeReference = useCallback(
    (reference: HTMLIFrameElement) => {
      if (activeElement !== reference) return;
      handleTrackGA4({
        action: "click",
        category: "nl",
        customized_parameters: {
          internal_campaign: campaignName ?? "",
          newsletter_name: lastSubscribedNewsletter ?? "",
          trigger_point: getTriggerPoint(variant),
        },
        subcategory: "like",
      });
    },
    [activeElement, handleTrackGA4, campaignName, variant, lastSubscribedNewsletter],
  );

  return (
    <Container {...props}>
      <Description> Follow us on Facebook to get our latest news.</Description>
      <FacebookIframe
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        allowFullScreen
        frameBorder={0}
        height="21"
        ref={iframeReference}
        scrolling="no"
        src={config.facebook.likeUrl}
        width="100"
      />
    </Container>
  );
};

FollowUsOnFacebook.displayName = "FollowUsOnFacebook";
